define.alias("shared/utils/array-filters/get-sum-of-extracted-values", "settings/utils/array-filters/get-sum-of-extracted-values");